var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryHr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_8675)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_8675",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_8675)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.66667H28V0H0V6.66667Z",
    fill: "#FF202D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 5.33329L11.3334 4.66663L12.0001 5.33329V6.66663H10.6667V5.33329ZM13.3334 5.33329L14.0001 4.66663L14.6667 5.33329V6.66663H13.3334V5.33329ZM16.6667 4.66663L16.0001 5.33329V6.66663H17.3334V5.33329L16.6667 4.66663Z",
    fill: "#1895DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 4.66663L12 5.33329V6.66663H13.3333V5.33329L12.6667 4.66663ZM15.3333 4.66663L14.6667 5.33329V6.66663H16V5.33329L15.3333 4.66663Z",
    fill: "#191F94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H28V13.3334H0V20Z",
    fill: "#2027AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 6.66663H11.3334L10.6667 7.99996H12.0001V9.33329H10.6667V10.6666H12.0001V12H10.6667V13.3333H12.0001V14.6666H13.3334V13.3333H14.6667V14.6666H16.0001V13.3333H17.3334V12H16.0001V10.6666H17.3334V9.33329H16.0001V7.99996H17.3334L16.6667 6.66663H16.0001V7.99996H14.6667V6.66663H13.3334V7.99996H12.0001V6.66663ZM13.3334 9.33329V7.99996H14.6667V9.33329H13.3334ZM13.3334 10.6666V9.33329H12.0001V10.6666H13.3334ZM14.6667 10.6666H13.3334V12H12.0001V13.3333H13.3334V12H14.6667V13.3333H16.0001V12H14.6667V10.6666ZM14.6667 10.6666H16.0001V9.33329H14.6667V10.6666Z",
    fill: "url(#paint0_linear_2858_8675)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2858_8675",
    x1: 10.6667,
    y1: 6.66663,
    x2: 10.6667,
    y2: 14.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF212E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD0D1B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_8675"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryHr);
export default __webpack_public_path__ + "static/media/Country=HR.88b429eef24aa437ae3a573741045d6e.svg";
export { ForwardRef as ReactComponent };